import ReCAPTCHA from './recaptcha';

export default ReCAPTCHA;
